let position = 1;

const dataLayerPush = (dataLayerObject) => {
  if (!dataLayerObject) return false;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(dataLayerObject);

  return true;
};

const getProductsArray = ({ products, list = '', setPosition = true }) => {
  let productsArray = [];

  products.forEach((product) => {
    let productId = product.id ? String(product.id) : undefined
    let variantSku = product.sku ? String(product.sku) : undefined
    let productName = product.title ? String(product.title) : undefined;

    if (!variantSku && !productName) return;

    let productCategory = product.product_type ? String(product.product_type) : undefined;
    let productBrand = product.vendor ? String(product.vendor) : '';
    let productList = list ? String(list) : '';

    let productImage = product.image ? String(product.image) : '';

    let productPrice = product.price ? parseFloat(product.price) : 0;
    let productCompareAtPrice = product.compare_at_price ? parseFloat(product.compare_at_price) : ''

    let productVariantId = product.objectID ? String(product.objectID) : '';

    let productPosition = position++;

    let productData = {
      'name': productName,
      'brand': productBrand,
      'price': productPrice,
      'product_id': productId,
      'variant_id': productVariantId,
      'compare_at_price': productCompareAtPrice,
      'image': productImage
    };

    if (variantSku) {
      productData['id'] = variantSku
    }

    if (productCategory) {
      productData['category'] = productCategory
    }

    if (productList) {
      productData['list'] = productList
    }

    if (setPosition) {
      productData['position'] = productPosition
    }

    productsArray.push(productData);
  });

  return productsArray;
};

const trackList = ({ products, list = '', resetPosition = false }) => {
  if (!products.length) return false;

  if (resetPosition) position = 1;

  let productsArray = getProductsArray({ products, list });

  if (!productsArray.length) return false;

  let dataLayerObject = {
    'event': 'dl_view_item_list',
    'ecommerce': {
      'currencyCode': Shopify.currency.active ?? '',
      'impressions': productsArray
    }
  };

  return dataLayerPush(dataLayerObject);
};

const trackListItemClick = ({ product, list = '' }) => {
  if (!product) return false;

  let productsArray = getProductsArray({ products: [product], list: list, setPosition: false });

  if (!productsArray.length) return false;

  let dataLayerObject = {
    'event': 'dl_select_item',
    'ecommerce': {
      'currencyCode': Shopify.currency.active ?? '',
      'click': {
        'products': productsArray
      }
    }
  };

  return dataLayerPush(dataLayerObject);
};

const trackSearchZeroResults = ({ searchTerm = '' }) => {
  let dataLayerObject = {
    'event': 'dl_view_search_results_zero',
    'search_term': searchTerm ?? '',
    'ecommerce': {
      'currencyCode': Shopify.currency.active ?? ''
    }
  };

  return dataLayerPush(dataLayerObject);
};

const trackSearch = ({ products, list = '', searchTerm = '', resetPosition = false }) => {
  if (!products.length) return trackSearchZeroResults({ searchTerm });

  if (resetPosition) position = 1;

  let productsArray = getProductsArray({ products, list });

  if (!productsArray.length) return false;

  let dataLayerObject = {
    'event': 'dl_view_search_results',
    'search_term': searchTerm ?? '',
    'ecommerce': {
      'currencyCode': Shopify.currency.active ?? '',
      'impressions': productsArray
    }
  };

  let productList = list ? String(list) : '';

  if (list) {
    dataLayerObject['actionField'] = {
      'list': productList
    }
  }

  return dataLayerPush(dataLayerObject);
};

trackWishlistAdd = ({ product, list = '' }) => {
  if (!product) return false;

  let productsArray = getProductsArray({ products: [product], list });

  if (!productsArray.length) return false;

  let dataLayerObject = {
    'event': 'dl_add_to_wishlist',
    'ecommerce': {
      'currencyCode': Shopify.currency.active ?? '',
      'impressions': productsArray
    }
  };

  return dataLayerPush(dataLayerObject);
};

const trackMarketChange = ({ marketSelected }) => {
  if (!marketSelected) return false;

  let dataLayerObject = {
    'event': 'dl_market_change',
    'market': marketSelected
  };

  return dataLayerPush(dataLayerObject);
};

const trackNotFound = () => {
  let dataLayerObject = {
    'event': 'dl_page_not_found'
  };

  return dataLayerPush(dataLayerObject);
};